module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/Img_browser-1b914764a4abd5a18338a6f739db2bf6.png";